import React, { Component } from 'react';

const NT = props => {
    return <span className="newthought">{props.children}</span>;
};

export default NT;
